<div class="h-16 bg-white border-b border-gray-200 shadow-sm flex items-center justify-between px-4 sm:px-6 lg:px-8">
    <div class="flex items-center gap-4">
        <a routerLink="/profilemanagement/dashboard" class="flex items-center gap-2">
            <img src="logo-black.png" alt="Logo" class="h-8 w-auto cursor-pointer" onerror="this.style.display='none'">
            <!-- <span class="text-xl font-bold text-brandPurple tracking-tight hidden sm:block">Retail Calculus - Scout</span> -->
        </a>
    </div>

    <!-- Right side items -->
    <div class="flex items-center divide-x divide-gray-200">
        <!-- User Info -->
        <div class="px-4 text-sm font-semibold text-gray-700 flex items-center gap-2">
            <div
                class="w-8 h-8 rounded-full bg-brandAccent text-white flex items-center justify-center font-bold text-xs shadow-sm ring-2 ring-transparent group-hover:ring-brandAccent/30 transition-all">
                {{ userName ? (userName.charAt(0) | uppercase) : 'U' }}
            </div>
            <!-- on page load to show loading text -->
            <span class="hidden sm:block text-gray-800">{{ userName || 'Loading...' }}</span>
        </div>

        <!-- Actions -->
        <div class="px-4 flex items-center gap-2">
            <button type="button" class="logout-btn" title="Logout" (click)="logout()" *ngIf="sessionModuleID != '-1'">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
            </button>
            <button *ngIf="sessionModuleID == '-1'" (click)="closeApp()" title="Close App"
                class="px-3 py-1.5 text-gray-600 hover:text-red-700 hover:bg-red-50 rounded-md transition-all flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-red-500/50">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <span class="text-sm font-bold hidden sm:block">Close</span>
            </button>
        </div>
    </div>
</div>